module.exports = __webpack_public_path__ + "assets/img/plan2-5.48bd7401.png";